import React from "react";

import { PageHeader } from "components/PageHeader";
import { Box, Grid } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import { useTheme } from "@mui/material/styles";

import { gridSpacing } from "utils/contants";

import { IDashboard } from "./interface";
import {
  Container,
  Content,
  Header,
  Body,
  ContainerByDate,
  BoxTime,
} from "./styles";
import MainCard from "../../ui-components/cards/MainCard";

export const AdminDashboardSkeleton: React.FC<IDashboard> = ({ isFull }) => {
  const theme = useTheme();

  const blockSX = {
    display: "flex",
    p: 2.5,
    borderLeft: "1px solid ",
    borderBottom: "1px solid ",
    borderTop: "1px solid ",
    borderRight: "1px solid ",
    height: 180,
    alignItem: "center",
    textTransform: "capitalize",
    borderLeftColor: theme.palette.grey[200],
    borderRightColor: theme.palette.grey[200],
    borderBottomColor: theme.palette.grey[200],
    borderTopColor: theme.palette.grey[200],
  };

  return (
    <Container isFull={isFull}>
      <PageHeader
        quantity={0}
        id="header"
        label={"Dashboard"}
        background="secondary"
        addClick={undefined}
        disabled={false}
      />
      <Content>
        <Header style={{ gridColumn: "1 / -1" }}>
          <ContainerByDate>
            {[1, 2, 3].map((id) => (
              <BoxTime key={id} id={id} selected={false}>
                <Skeleton height={16} width={50} />
              </BoxTime>
            ))}
          </ContainerByDate>
        </Header>

        <Body style={{ gridColumn: "1 / -1" }}>
          <Box sx={{ width: "100%" }}>
            <Grid container spacing={gridSpacing}>
              <Grid item xs={12}>
                <MainCard
                  content={false}
                  sx={{
                    "& svg": {
                      width: 25,
                      height: 25,
                      color: theme.palette.secondary.main,
                      borderRadius: "14px",
                      p: 1.25,
                    },
                  }}
                >
                  <Grid container alignItems="center" spacing={0}>
                    {[1, 2].map((index) => (
                      <Grid key={index} item xs={12} sm={6} sx={blockSX}>
                        <Grid
                          container
                          alignItems="center"
                          spacing={1}
                          justifyContent="center"
                        >
                          <Grid
                            item
                            sx={{
                              "& svg": {
                                bgcolor:
                                  theme.palette.mode === "dark"
                                    ? theme.palette.background.default
                                    : "primary.light",
                              },
                            }}
                          >
                            <Skeleton
                              variant="circular"
                              height={25}
                              width={25}
                            />
                          </Grid>
                          <Grid item sm zeroMinWidth>
                            <Skeleton
                              height={20}
                              width={120}
                              style={{ marginBottom: "8px" }}
                            />
                            <Skeleton height={24} width={40} />
                          </Grid>
                          <Grid
                            sx={{
                              marginTop: -20,
                              marginRight: 5,
                              width: 2,
                              height: 2,
                            }}
                          >
                            <Skeleton
                              variant="circular"
                              height={16}
                              width={16}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>

                  <Grid container alignItems="center" spacing={0}>
                    {[1, 2].map((index) => (
                      <Grid key={index} item xs={12} sm={6} sx={blockSX}>
                        <Grid
                          container
                          alignItems="center"
                          spacing={1}
                          justifyContent="center"
                        >
                          <Grid
                            item
                            sx={{
                              "& svg": {
                                bgcolor:
                                  theme.palette.mode === "dark"
                                    ? theme.palette.background.default
                                    : "primary.light",
                              },
                            }}
                          >
                            <Skeleton
                              variant="circular"
                              height={25}
                              width={25}
                            />
                          </Grid>
                          <Grid item sm zeroMinWidth>
                            <Skeleton
                              height={20}
                              width={120}
                              style={{ marginBottom: "8px" }}
                            />
                            <Skeleton height={24} width={40} />
                          </Grid>
                          <Grid
                            sx={{
                              marginTop: -20,
                              marginRight: 5,
                              width: 2,
                              height: 2,
                            }}
                          >
                            <Skeleton
                              variant="circular"
                              height={16}
                              width={16}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                </MainCard>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ width: "100%" }}>
            <Grid container spacing={gridSpacing}>
              <Grid item xs={12}>
                <MainCard
                  content={false}
                  sx={{
                    "& svg": {
                      width: 25,
                      height: 25,
                      color: theme.palette.secondary.main,
                      borderRadius: "14px",
                      p: 1.25,
                    },
                  }}
                >
                  <Grid container alignItems="center" spacing={0}>
                    {[1, 2].map((index) => (
                      <Grid key={index} item xs={12} sm={6} sx={blockSX}>
                        <Grid
                          container
                          alignItems="center"
                          spacing={1}
                          justifyContent="center"
                        >
                          <Grid
                            item
                            sx={{
                              "& svg": {
                                bgcolor:
                                  theme.palette.mode === "dark"
                                    ? theme.palette.background.default
                                    : "primary.light",
                              },
                            }}
                          >
                            <Skeleton
                              variant="circular"
                              height={25}
                              width={25}
                            />
                          </Grid>
                          <Grid item sm zeroMinWidth>
                            <Skeleton
                              height={20}
                              width={120}
                              style={{ marginBottom: "8px" }}
                            />
                            <Skeleton height={24} width={40} />
                          </Grid>
                          <Grid
                            sx={{
                              marginTop: -20,
                              marginRight: 5,
                              width: 2,
                              height: 2,
                            }}
                          >
                            <Skeleton
                              variant="circular"
                              height={16}
                              width={16}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>

                  <Grid container alignItems="center" spacing={0}>
                    {[1, 2].map((index) => (
                      <Grid key={index} item xs={12} sm={6} sx={blockSX}>
                        <Grid
                          container
                          alignItems="center"
                          spacing={1}
                          justifyContent="center"
                        >
                          <Grid
                            item
                            sx={{
                              "& svg": {
                                bgcolor:
                                  theme.palette.mode === "dark"
                                    ? theme.palette.background.default
                                    : "primary.light",
                              },
                            }}
                          >
                            <Skeleton
                              variant="circular"
                              height={25}
                              width={25}
                            />
                          </Grid>
                          <Grid item sm zeroMinWidth>
                            <Skeleton
                              height={20}
                              width={120}
                              style={{ marginBottom: "8px" }}
                            />
                            <Skeleton height={24} width={40} />
                          </Grid>
                          <Grid
                            sx={{
                              marginTop: -20,
                              marginRight: 5,
                              width: 2,
                              height: 2,
                            }}
                          >
                            <Skeleton
                              variant="circular"
                              height={16}
                              width={16}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                </MainCard>
              </Grid>
            </Grid>
          </Box>
        </Body>
      </Content>
    </Container>
  );
};
